import React from 'react';
import Link from 'components/lowLevel/Link';
import { ComboBoxOption } from '../../../../../services/Main/types.Field';
import useStyles from './Tags.styles';

const Tag = ({ href, label }: ComboBoxOption) => {
  const classes = useStyles();

  if (href) {
    return (
      <div className={classes.textTag}>
        <Link className={classes.link} to={href}>
          {label}
        </Link>
      </div>
    );
  }

  return <div className={classes.textTag}>{label}</div>;
};

export default Tag;
